exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#reschedulingReceiverPage[data-v-8de6e8da] {\n  text-align: center;\n  font-family: 'Avenir','Helvetica Neue','Helvetica','Arial','Hiragino Sans','\\30D2\\30E9\\30AE\\30CE\\89D2\\30B4\\30B7\\30C3\\30AF',YuGothic,'Yu Gothic','\\30E1\\30A4\\30EA\\30AA', Meiryo,'\\FF2D\\FF33   \\FF30\\30B4\\30B7\\30C3\\30AF','MS PGothic', 'sans-serif';\n  margin-bottom: 50px;\n}\n.header[data-v-8de6e8da] {\n  background-color: #ffd500;\n  text-align: center;\n  font-size: 24px;\n  font-weight: bold;\n  text-shadow:  -2px 2px 2px white,\n                -2px -2px 2px white,\n                2px -2px 2px white,\n                2px 2px 2px white;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-8de6e8da","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReschedulingPage/ReschedulingListPage.vue
// module id = 538
// module chunks = 0